import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getLogsList(currentPage, pageSize) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/logs`,
    method: 'get',
    params: {
      currentPage, pageSize,
    },
  });
}

export function findLog(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/logs/${ id }`,
    method: 'get',
  });
}

export function saveLog(log) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/logs`,
    method: 'post',
    data: log,
  });
}
